import { render, staticRenderFns } from "./ClusterDashboard.vue?vue&type=template&id=0c17478e"
import script from "./ClusterDashboard.vue?vue&type=script&lang=js"
export * from "./ClusterDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports